import { createAction } from 'redux-actions'

export const POINTS_SET_POINTS = createAction('SET_POINTS')
export const POINTS_SET_SELECTED_POINT_START = createAction('POINTS_SET_SELECTED_POINT_START')
export const POINTS_SET_SELECTED_POINT_SUCCEEDED = createAction('POINTS_SET_SELECTED_POINT_SUCCEEDED')
export const POINTS_SET_SELECTED_POINT_FINALLY = createAction('POINTS_SET_SELECTED_POINT_FINALLY')
export const POINTS_CREATE_CACHE = createAction('POINTS_CREATE_CACHE')
export const POINTS_CREATE_CACHE_START = createAction('POINTS_CREATE_CACHE_START')
export const POINTS_CREATE_CACHE_SUCCEEDED = createAction('POINTS_CREATE_CACHE_SUCCEEDED')
